import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCheck, MdLocationPin, MdSearch } from "react-icons/md";
import logo from '../assets/logo.png';

export default function Footer(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection bg-dark"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px",
					borderTop: "1px solid var(--secondaryColor)"
				}}
			>
				<div className="container">
					<div className="row">
						
						<div className="col-md-4">
							<h6
								className="text-primary font-bold"
							>
								Useful Links
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "",
									})
								}}
								className="btn font-bold text-light"
							>
								Home
							</h6>

							
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "about_us",
									})
								}}
								className="font-bold text-light"
							>
								About Us
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "services",
									})
								}}
								className="font-bold text-light"
							>
								Services
							</h6>


							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									appContext.navTo({
										item: "contact_us",
									})
								}}
								className="font-bold text-light"
							>
								Contact Us
							</h6>
						</div>

						<div className="col-md-4">
							<h6
								className="text-primary font-bold"
							>
								Address
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								
								className="font-bold text-light"
							>
								KOBE KONSULT LTD <br/><br/>
								P.O.BOX 32187, Dar es Salaam<br/><br/>
								Kijitonyama - Off- Shekilango Road / Bahari Beach, Ununio Road, Kinondoni Municipality, Dar es Salaam, Tanzania
							</h6>
							
						</div>

						<div className="col-md-4">
							<h6
								className="text-primary font-bold"
							>
								Reach Out
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
								}}
								
								className="font-bold text-light"
							>
								+255 754300767/ +255 783350234<br/><br/>
								mail@kobekonsult.com <br/><br/>
								info@kobekonsult.com <br/><br/>
								george@kobekonsult.com <br/><br/>
								kobe@kobekonsult.com

							</h6>
							
						</div>

						<div className="col-md-12 d-flex justify-content-center mt-5">
							<img src={logo} width={200} />
						</div>

						<div className="col-md-12 text-center font-bold">
							<h6
								style={{
									fontSize: "14px",
									paddingTop: "30px"
								}}
								className="text-light"
							>
								&copy;KOBE KONSULT LTD - {getCurrentYear()}
							</h6>
							<br />
							<hr/>
							<h6
								style={{
									fontSize: "14px",
									paddingTop: "30px"
								}}
								className="text-light"
							>
								website designed by <a href="http://werenium.com">Werenium Technologies</a>
							</h6>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}